import React, { useMemo, useRef } from "react";
import style from "./Markdown.module.css";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./styles.css";

// Configure Quill to allow table elements
const Block = Quill.import('blots/block');
const BlockEmbed = Quill.import('blots/block/embed');

class TableBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.innerHTML = value;
    return node;
  }
  
  static value(node) {
    return node.innerHTML;
  }
}
TableBlot.blotName = 'table';
TableBlot.tagName = 'table';

Quill.register(TableBlot);

const Markdown = ({ value, setValue, setText, placeholder }) => {
  const quillRef = useRef(null);

  // Custom table insertion handler
  const insertTable = () => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = quill.getSelection(true);
    const tableHTML = `<tr><td><br /></td><td><br /></td><td><br /></td></tr><tr><td><br /></td><td><br /></td><td><br /></td></tr><tr><td><br /></td><td><br /></td><td><br /></td></tr>`;
    
    quill.insertEmbed(range.index, 'table', tableHTML, Quill.sources.USER);
    quill.insertText(range.index + 1, '\n', Quill.sources.USER);
    quill.setSelection(range.index + 2, Quill.sources.SILENT);
  };

  const modules = useMemo(() => ({
            toolbar: {
              container: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike", "blockquote", "code-block", { script: "sub" }, { script: "super" }, "link"],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                [{ align: "center" }, { align: "" }, { align: "right" }, { align: "justify" }],
                [{ color: [] }, { background: [] }],
                [{ font: [] }],
                [{ size: ["8px", "10px", "12px", "14px", "18px", "24px", "36px"] }],
                ["insertTable"],
                ["clean"],
              ],
              handlers: {
                insertTable: insertTable,
              },
            },
            clipboard: {
              matchVisual: false,
            },
          }), []);

  return (
    <>
      <div className={`${style.field}`}>
        <ReactQuill
          ref={quillRef}
          placeholder="Add Description here..."
          theme="snow"
          modules={modules}
          value={value}
          onChange={(val, delta, _, content) => {
            // Clean up empty list items that cause extra bullets
            const cleanedVal = val
              .replace(/<li>\s*<\/li>/g, '') // Remove completely empty li
              .replace(/<li><br><\/li>/g, '') // Remove li with only br
              .replace(/<li>\s*<br\s*\/?>\s*<\/li>/g, ''); // Remove li with br and whitespace
            
            setValue(cleanedVal);
            setText(content.getText());
          }}
        />
        {/* <Editor
          apiKey="v1oaw3yn9un79c63uodd74j2ecckl6kpejp444c7divbpm6m"
          onEditorChange={(val, editor) => {
            setValue(val);
            setText(editor.getContent({ format: "text" }));
          }}
          value={value}
          init={{
            placeholder: "Add Description here...",
            height: 300,
            plugins: ["fullscreen", "wordcount", "table"],
            toolbar: "undo redo | styles | " + "bold italic backcolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | fullscreen",
          }}
        /> */}
      </div>
    </>
  );
};

export default Markdown;
